/**
 * PC Remote Library
 * Author: Divya Tiwari
 * Created On: 13-03-2023
 */

import React from 'react';
import AvoidedCarbonEmission from '../CO2StatusComponent/AvoidedCarbonEmission';
import '../../shared/LibraryTheme.scss';
import ReduceEnergyUsage from '../EnergyStatusComponent/ReduceEnergyUsage';
import TimerComponent from '../TimerComponent/TimerComponent';
import building from '../../assets/building.svg';
interface IDSIBOSecondPageProps {
  carbonBaselineWithoutIBO: number;
  carbonConsumptionWithIBO: number;
  carbonReduction: number;
  pastCRDisplayPercentage: number | undefined | null;
  carbonReductionIncreased: boolean;
  energyBaselineWithoutIBO: number;
  energyConsumptionWithIBO: number;
  energySavings: number;
  screenOption: string;
  pastESDisplayPercentage: number | undefined | null;
  energySavingsIncrased: boolean;
  totalDays: string;
  timer: number;
}

/**
 *
 * Component to display Carbon Usage Graph
 *
 */

const DSIBOSecondPage = (props: IDSIBOSecondPageProps) => {
  let screenOption = props.screenOption.toLowerCase();

  let withIboBuildingHeading, carbonEmissionPage;
  if (screenOption === 'landscape') {
    carbonEmissionPage = 'ds-ibo-second-page-container';
    withIboBuildingHeading = 'align-center';
  } else {
    carbonEmissionPage = 'ds-ibo-second-page-container ds-portrait-container';
    withIboBuildingHeading = 'ds-ibo-heading-portrait';
  }
  return (
    <div className={carbonEmissionPage}>
      <TimerComponent />
      <div className={withIboBuildingHeading}>
        {/* <div className="ds-ibo-heading">In this week</div> */}
        <div className="ds-ibo-sub-heading">
        With sustainability initiatives, this building
        </div>
      </div>
      {screenOption !== 'landscape' && (
        <div className="slide-seconde-container-portrait">
          <div className="co2">
            <AvoidedCarbonEmission
              carbonBaselineWithoutIBO={props.carbonBaselineWithoutIBO}
              carbonConsumptionWithIBO={props.carbonConsumptionWithIBO}
              carbonReduction={props.carbonReduction}
              screenOption={screenOption}
              pastCRDisplayPercentage={props.pastCRDisplayPercentage}
              carbonReductionIncreased={props.carbonReductionIncreased}
              totalDays={props.totalDays}
            />
          </div>
          <div className="energy">
            <ReduceEnergyUsage
              screenOption={screenOption}
              totalDays={props.totalDays}
              energyBaselineWithoutIBO={props.energyBaselineWithoutIBO}
              energyConsumptionWithIBO={props.energyConsumptionWithIBO}
              energySavings={props.energySavings}
              pastESDisplayPercentage={props.pastESDisplayPercentage}
              energySavingsIncrased={props.energySavingsIncrased}
            />
          </div>
          <div className="image">
            <img src={building} className="building-image" />
          </div>
        </div>
      )}
      {screenOption === 'landscape' && (
        <div className="inside-container">
          <div className="co2">
            <AvoidedCarbonEmission
              carbonBaselineWithoutIBO={props.carbonBaselineWithoutIBO}
              carbonConsumptionWithIBO={props.carbonConsumptionWithIBO}
              carbonReduction={props.carbonReduction}
              screenOption={props.screenOption}
              pastCRDisplayPercentage={props.pastCRDisplayPercentage}
              carbonReductionIncreased={props.carbonReductionIncreased}
              totalDays={props.totalDays}
            />
          </div>
          <div className="image">
            <img src={building} className="building-image" />
          </div>
          <div className="energy">
            <ReduceEnergyUsage
              screenOption={props.screenOption}
              totalDays={props.totalDays}
              energyBaselineWithoutIBO={props.energyBaselineWithoutIBO}
              energyConsumptionWithIBO={props.energyConsumptionWithIBO}
              energySavings={props.energySavings}
              pastESDisplayPercentage={props.pastESDisplayPercentage}
              energySavingsIncrased={props.energySavingsIncrased}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DSIBOSecondPage;
